import React from 'react'
import PropTypes from 'prop-types'
import { Col } from 'reactstrap'

class TaxReturnTileContainer extends React.Component {
  render () {
    return (
      <Col md='6' lg='4' xl='3'>
        {this.props.children}
      </Col>
    )
  }
}

TaxReturnTileContainer.propTypes = {
  children: PropTypes.node.isRequired
}

export { TaxReturnTileContainer }
